import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./payment.scss";
import { useDispatch, useSelector } from "react-redux";
import { IoIosWarning } from "react-icons/io";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";
import { updateQuantity } from "../../redux/cartReducer";
import Loading from "../../components/loading/Loading";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import InstantPaymentForm from "../../components/paymentGatway/InstantPaymentForm";
import FeaturedProducts from "../../components/FeaturedProducts/FeaturedProducts";

const stripePromise = loadStripe(
  "pk_live_51NZq6pLFX6mtMcpcmmo6KvEu2tURioX0Ip3uTWUs0eZGPLe3qVUpyXcR3H27pfrkt7PQ1izb6sK5LTW2FmzEF4Sp00jGDUWGNH"
);

const Payment = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [homeName, setHomeName] = useState("");
  const [landmark, setLandmark] = useState("");
  const [qrCode, setQrCode] = useState(null);
  const dispatch = useDispatch();
  const [varifyMail, setVarifyMail] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [paymentMethord, setPaymentMethord] = useState("");
  const [orderId, setOrderId] = useState("");
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const generateUniqueNumber = () => {
    const uniqueNumber = "NOT-" + Date.now();
    setOrderId(uniqueNumber);
  };

  setTimeout(() => {
    setError("");
  }, 50000);

  // const devApiLink = "http://localhost:4047/api/v1";

  const devApiLink = "https://chocodate-api.notionspromos.com/api/v1";

  // console.log(varifyMail);

  useEffect(() => {
    if (!qrCode) {
      return;
    }

    const getVarifyCode = async () => {
      setLoading(true);
      try {
        await axios
          .get(`${devApiLink}/varifyCode/${qrCode}`)
          .then((response) => {
            const isCodeValid = response.data.code;
            setApiResponse(isCodeValid);
          });
      } catch (error) {
        setError("Code not valid or Already Used");
      } finally {
        setLoading(false);
      }
    };

    getVarifyCode();
  }, [qrCode]);

  const statusCode = () => {
    if (apiResponse?.qr) {
      return <FaCheckCircle color="#39e75f" />;
    }
    if (qrCode === null && !apiResponse?.qr) {
      return;
    }
    if (!apiResponse?.qr) {
      return (
        <div
          style={{
            padding: "5px 10px",
            backgroundColor: "red",
            color: "#00000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <strong
            style={{
              fontSize: "12px",
              color: "white",
              fontWeight: 600,
            }}
          >
            wrong code or code already used
          </strong>
        </div>
      );
    }
    if (loading) {
      return <small>Loading... </small>;
    } else {
      return;
    }
    return null; // Ensures the function always returns something, even if no conditions are met
  };

  const gift = () => {
    if (
      apiResponse?.winItemName === "Mobile Phone" ||
      apiResponse?.winItemName === "GOLD COIN" ||
      apiResponse?.winItemName === "2 Movie Ticket" ||
      apiResponse?.winItemName === "1 Free Family pack"
    ) {
      return (
        <span style={{ fontSize: "13px" }}>
          Contact support@notionsgroup.com to claim your prize!
        </span>
      );
    }
    if (apiResponse?.winItemName === "50% Off on next order") {
      return <span>Enjoy 50% off your total purchase!</span>;
    }
    // Default return when none of the above conditions match
    return <span>{apiResponse?.winItemName}</span>;
  };

  useEffect(() => {
    generateUniqueNumber();
  }, []);

  useEffect(() => {
    if (!email) {
      return;
    } else {
      const checkMail = apiResponse?.userEmail === email;
      setVarifyMail(checkMail);
    }
  }, [email]);

  const products = useSelector((state) => state.cart.products);

  const delivaryAmout = 20;
  const delivaryAmoutLess = 10;
  const noDelivaryAmout = 0;

  const totals = products.reduce(
    (acc, product) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity, 10);
      acc.totalPrice += price * quantity;
      acc.totalItems += quantity;

      return acc;
    },
    { totalPrice: 0, totalItems: 0 }
  );

  const netOderBefore = totals.totalPrice;
  const addCoupon = () => {
    if (!apiResponse?.winItemName) {
      return;
    }
    if (
      apiResponse?.winItemName === "50% Off on next order" &&
      varifyMail === true
    ) {
      const value = netOderBefore / 2;
      return value;
    } else {
      return;
    }
  };

  const addCouponValue = parseInt(addCoupon());
  const finalVale = () => {
    if (!addCouponValue) {
      return netOderBefore;
    } else {
      const couponValue = netOderBefore - Number(addCouponValue);
      return couponValue;
    }
  };

  const netOder = finalVale();

  const withDelivaryCost = () => {
    let netTotal;
    if (netOder < 50) {
      netTotal = netOder + delivaryAmout;
    } else if (netOder >= 50 && netOder < 75) {
      netTotal = netOder + delivaryAmoutLess;
    } else if (netOder >= 75) {
      netTotal = netOder + noDelivaryAmout;
    } else {
      return; // Return nothing if no conditions are met
    }

    return netTotal.toFixed(2); // Ensures the value is fixed to two decimal places
  };

  const getdeliveryCost = () => {
    if (netOder < 50) {
      return 20;
    } else if (netOder >= 50 && netOder < 75) {
      return 10;
    } else {
      return 0;
    }
  };
  const deliveryCost = getdeliveryCost();
  const finalCost = withDelivaryCost();
  const productsData = {
    totals: finalCost,
    qut: totals.totalItems,
    fullName,
    email,
    price: finalCost,
    name: fullName,
    title: fullName,
    quantity: totals.totalItems,
  };

  const hanldPlaceOrder = async (e) => {
    if (e) e.preventDefault();

    if (!paymentMethord || paymentMethord === "") {
      setError("Select your payment method");
      return;
    }

    const orderData = {
      fullName,
      email,
      products,
      brand: "snacksfactory",
      num_pieces: productsData.qut,
      totalAmount: productsData.totals,
      descripon: products.title,
      lrCode: products.lrCode,
      city,
      landmark,
      address,
      homeName,
      orderId,
      phone,
      deliveryCost,
      sessionId,
      paymentMethod: paymentMethord,
    };

    try {
      setBtnLoading(true);
      // ✅ Wait for API response
      const res = await axios.post("/create_order", orderData);
      return res;
    } catch (error) {
      console.error("Order API Error:", error);
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setBtnLoading(false);
    }
  };

  const massageDisplay_75 = () => {
    if (netOder < 75) {
      let value = 75 - netOder;
      return ` You're just AED ${value.toFixed(2)} away from free delivery! `;
    } else {
      return " 🥳  Woo.. hoo.. you're eligible for free delivery 🚚 ";
    }
  };

  const massgeDisplay_50 = () => {
    if (netOder < 50) {
      let valueTwo = 50 - netOder;
      return `  Or,Add just AED ${valueTwo.toFixed(
        2
      )} to slash your delivery fee to AED 10. `;
    } else {
      return;
    }
  };

  const inital = netOder === 0 ? "hide" : "";

  const options = {
    appearance: {
      theme: "flat",
      variables: {
        colorPrimary: "#0570de",
        colorBackground: "#ffffff",
        colorText: "#30313d",
        colorDanger: "#df1b41",
        fontFamily: "Ideal Sans, system-ui, sans-serif",
        spacingUnit: "2px",
        borderRadius: "4px",
      },
      rules: {
        ".Tab": {
          border: "1px solid #E0E6EB",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03)",
        },
        ".Tab:hover": {
          color: "var(--colorText)",
        },
        ".Tab--selected": {
          borderColor: "#E0E6EB",
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)",
        },
      },
    },
  };

  const amount = withDelivaryCost();

  const isFormValid =
    fullName.trim() !== "" &&
    email.trim() !== "" &&
    phone.trim() !== "" &&
    city.trim() !== "" &&
    address.trim() !== "" &&
    homeName.trim() !== "" &&
    landmark.trim() !== "";

  return (
    <div className="__fw">
      <div className="__mw">
        {loading ? (
          <Loading />
        ) : (
          <div className="payment">
            <div className="pay_info">
              <div className="pro_list">
                <div className="pro_hed">
                  <h5>
                    Order <em>summary</em>{" "}
                  </h5>
                </div>
                {products.length > 0 ? (
                  <div className="all_pro_list">
                    {products.map((product, index) => (
                      <div className="pro_card" key={index}>
                        <div className="pro_card_in">
                          <div className="img_wrp">
                            <img
                              src={
                                `${process.env.REACT_APP_DOC_VIEW_LINK}/` +
                                product.img
                              }
                              alt=""
                            />
                          </div>
                          <div className="info_wrp">
                            <span>
                              <em>
                                {product.name} {product.weight}
                              </em>
                            </span>
                          </div>
                          <div className="info_wrp">
                            <span>
                              <em>Qut:</em> {product.quantity}
                            </span>
                          </div>
                          <div className="info_wrp">
                            <span>
                              <em>AED </em>{" "}
                              {(product.price * product.quantity).toFixed(2)}
                            </span>
                          </div>
                          <div className="qut_wrp">
                            <button
                              className="_btn"
                              onClick={() =>
                                dispatch(
                                  updateQuantity({
                                    id: product.id,
                                    quantity:
                                      product.quantity === 1
                                        ? 1
                                        : product.quantity - 1,
                                  })
                                )
                              }
                            >
                              -
                            </button>
                            <strong
                              style={{
                                margin: "0px 20px",
                                fontSize: "12px",
                              }}
                            >
                              {product.quantity}
                            </strong>

                            <button
                              className="_btn"
                              onClick={() => {
                                if (
                                  product.flashMaxPcs === 0 ||
                                  product.quantity < product.flashMaxPcs
                                ) {
                                  dispatch(
                                    updateQuantity({
                                      id: product.id,
                                      quantity: product.quantity + 1,
                                    })
                                  );
                                } else {
                                  import("react-toastify").then(({ toast }) =>
                                    toast.warn(
                                      `Max limit reached (${product.flashMaxPcs} pcs)`
                                    )
                                  );
                                }
                              }}
                              disabled={
                                product.flashMaxPcs !== 0 &&
                                product.quantity >= product.flashMaxPcs
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                        {/* <div className="pro_des">
                          <em>{product.desc}</em>
                        </div> */}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No products in the cart</p>
                )}
                {/* <div className="total_wrp bg">
                  <span>Have coupon ? </span>
                  <span>{statusCode()}</span>
                  <input
                    value={qrCode}
                    onChange={(e) => setQrCode(e.target.value)}
                    placeholder="ABC123"
                    type="text"
                  />
                </div> */}
                {!apiResponse ? (
                  <>{/* <Loading /> */}</>
                ) : (
                  <>
                    <div
                      style={{ backgroundColor: "rgb(57, 231, 95)" }}
                      className="total_wrp"
                    >
                      <span style={{ color: "white", fontWeight: "600" }}>
                        {gift()}
                      </span>
                      <em
                        style={{
                          fontStyle: "normal",
                          fontSize: "10px",
                          marginLeft: "10px",
                        }}
                      >
                        {!varifyMail &&
                          "Alos use your registered email on Always a winner! to get exclusive discounts!"}
                      </em>
                    </div>
                  </>
                )}
                <div className="total_wrp">
                  <span>Items Total</span>
                  <span>AED {netOderBefore?.toFixed(2)}</span>
                </div>
                {apiResponse && (
                  <>
                    {varifyMail && (
                      <>
                        <div className="total_wrp">
                          <span>Discount value </span>
                          <span style={{ color: "red" }}>
                            AED ( {addCouponValue?.toFixed(2)} )
                          </span>
                        </div>
                      </>
                    )}
                  </>
                )}
                {varifyMail === true && (
                  <div className="total_wrp">
                    <span>Sub Total</span>
                    <span>AED {netOder.toFixed(2)}</span>
                  </div>
                )}

                <div className="total_wrp">
                  <span>Delivery Charges</span>
                  <span>AED {deliveryCost.toFixed(2)}</span>
                </div>
                <hr />
                <div className="total_wrp">
                  <h4>Total</h4> <h4>AED {withDelivaryCost()}</h4>{" "}
                </div>
              </div>
              <div className="msgShow">
                <span style={{ fontWeight: 400 }}>
                  {massageDisplay_75()}
                  {massgeDisplay_50()}
                  Don't miss out—shop a little more and save big!
                </span>
              </div>
            </div>
            <div className="check_right">
              <div className="check_form">
                <div>
                  <strong>Customer details</strong>
                </div>
                <div className="form">
                  <div className="from_wrp">
                    <div className="input_wrp">
                      <label>First name</label>
                      <input
                        required
                        type="text"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                      />
                    </div>
                    <div className="input_wrp">
                      <label>Email</label>
                      <input
                        required
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="from_wrp">
                    <div className="input_wrp">
                      <label>Phone Number</label>
                      <input
                        required
                        value={phone}
                        type="text"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="from_wrp">
                    <div className="input_wrp">
                      <label>City</label>

                      <select
                        name="city"
                        class="form-control save_data"
                        id="city"
                        value={city}
                        required="required"
                        onChange={(e) => setCity(e.target.value)}
                      >
                        <option>Select Your City </option>
                        <option value="Abu Dhabi">Abu Dhabi</option>
                        <option value="Dubai">Dubai</option>
                        <option value="Sharjah">Sharjah</option>
                        <option value="Ajman">Ajman</option>
                        <option value="Umm Al-Quwain">Umm Al-Quwain</option>
                        <option value="Fujairah">Fujairah</option>
                        <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                        <option value="Al-Ain">Al-Ain</option>{" "}
                      </select>
                    </div>

                    <div className="input_wrp">
                      <label>Address</label>
                      <input
                        required
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="from_wrp">
                    <div className="input_wrp">
                      <label>House No. or Name</label>
                      <input
                        required
                        type="text"
                        value={homeName}
                        onChange={(e) => setHomeName(e.target.value)}
                      />
                    </div>
                    <div className="input_wrp">
                      <label>Landmark</label>
                      <input
                        required
                        type="text"
                        value={landmark}
                        onChange={(e) => setLandmark(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="payment_methord">
                    <h6>Select Payment method</h6>
                    <div className="p_in">
                      <div className="_p_wrp" style={{ cursor: "not-allowed" }}>
                        <input
                          type="radio"
                          value="cod"
                          disabled
                          checked={paymentMethord === "cod"}
                          onChange={(e) => setPaymentMethord(e.target.value)}
                        />{" "}
                        <strong>COD</strong>
                      </div>
                      <div
                        className="_p_wrp"
                        style={{
                          backgroundColor: isFormValid ? "#d4ffd4" : "#f0f0f0", // green ✅ or light gray ❌
                          border: "1px solid #7cc47cff",
                          padding: "10px",
                          borderRadius: "6px",
                        }}
                      >
                        <input
                          type="radio"
                          value="card"
                          disabled={!isFormValid}
                          checked={paymentMethord === "card"}
                          onChange={(e) => setPaymentMethord(e.target.value)}
                        />{" "}
                        <strong>Card</strong>
                      </div>
                    </div>
                  </div>

                  {paymentMethord === "card" && (
                    <div className="payment_form">
                      <div className="paymen_wrp">
                        <Elements stripe={stripePromise} options={options}>
                          <InstantPaymentForm
                            orderId={orderId}
                            amount={amount}
                            hanldPlaceOrder={hanldPlaceOrder}
                          />
                        </Elements>
                      </div>
                    </div>
                  )}

                  {/* {paymentMethord === "card" && (
                    <>
                      {btnLoading ? (
                        <div className="pay_btn">
                          <span className="checkout">Please Wait...</span>
                        </div>
                      ) : (
                        <div className="pay_btn">
                          <button
                            className="checkout"
                            onClick={hanldPlaceOrder}
                          >
                            Continue
                          </button>
                        </div>
                      )}
                    </>
                  )} */}
                </div>
                {error && (
                  <span style={{ color: "#ff0000ff", fontSize: "14px" }}>
                    {error}
                  </span>
                )}{" "}
                <br />
                <span style={{ color: "#ff0000ff", fontSize: "12px" }}>
                  <IoIosWarning color="orange" size={20} /> Note: Please do not
                  close this page until your order is confirmed.
                </span>
              </div>
            </div>
          </div>
        )}
        <div className="cont_wrp">
          <FeaturedProducts type="featured" />
        </div>
      </div>
    </div>
  );
};

export default Payment;
